import { BaseTool } from '../BaseTool';

export class MaterialsTool extends BaseTool {
    id = 'MANAGE_MATERIALS';
    name = 'Materials';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('materials');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
